import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Asian%20spring%20landscape%2C%20cherry%20blossom%20trees%20in%20full%20bloom%20surrounding%20ancient%20temple%20by%20lake%2C%20snow-capped%20mountain%20in%20distance%2C%20golden%20morning%20light%2C%20misty%20atmosphere%2C%20dreamy%20pastel%20pink%20and%20green%20color%20palette%2C%20wide%20cinematic%20composition%2C%20travel%20editorial%20photography&width=1920&height=1080&seq=hero-spring-asia-01&orientation=landscape"
        alt="亚洲春色 - 感受春日亚洲最美风情"
        title="亚洲春色 - 春季亚洲旅行"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full text-center px-6">
        <p className="text-white/80 text-sm md:text-base tracking-widest mb-4 animate-[fadeInUp_0.8s_ease-out]">
          探索亚洲 · 发现春天
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight max-w-4xl mx-auto animate-[fadeInUp_0.8s_ease-out_0.1s]">
          亚洲春色
        </h1>
        <p className="mt-4 text-white/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed animate-[fadeInUp_0.8s_ease-out_0.2s]">
          汇聚东亚、东南亚、南亚春季最绚烂的自然与人文景观，带你领略樱花、油菜花、热带花海的极致美景
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4 animate-[fadeInUp_0.8s_ease-out_0.3s]">
          <Link
            to="/category/east-asia"
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            探索春色
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 text-white rounded-full text-sm font-medium hover:bg-white/10 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <span className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-s-line text-2xl"></i>
        </span>
      </div>
    </section>
  );
}